// extracted by mini-css-extract-plugin
export default {"container":"languageSelector_container__281M1","active":"languageSelector_active__uaC5F"};